import React from "react";
import { useAuth } from "../hooks/useAuth";
import AccountMenu from "./AccountMenu";

export default function Navbar({ onLoginClick, onVerificationSubmitted }) {
  const { user, loading, logout } = useAuth();

  const initials = user?.displayName
    ? user.displayName.split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase()
    : user?.email?.[0]?.toUpperCase() ?? (user?.phoneNumber ? "📱" : "U");

  // Phone sign-in users have no name or email; show their number instead.
  const label = user?.displayName || user?.email?.split("@")[0] || user?.phoneNumber || "Account";

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <span className="brand-jb">Janmabhoomi</span>
        <span className="brand-plus">JB+</span>
      </div>

      <div className="navbar-actions">
        {loading ? (
          // Tiny spinner while Firebase resolves auth state
          <span className="spinner" style={{
            borderColor: "rgba(1,113,187,0.25)",
            borderTopColor: "#0171BB",
            width: 20, height: 20,
          }} />
        ) : user ? (
          <>
            <AccountMenu
              initials={initials}
              label={label}
              onVerificationSubmitted={onVerificationSubmitted}
            />
            <button className="btn-ghost" onClick={logout}>
              Sign out
            </button>
          </>
        ) : (
          <>
            <button className="btn-ghost nav-signin" onClick={onLoginClick}>
              Sign in
            </button>
            <button className="btn-primary" onClick={onLoginClick}>
              Get JB+
            </button>
          </>
        )}
      </div>
    </nav>
  );
}
